// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gw8n","select":"styles_select__2k1_4"};